import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomerData } from "@cinch-labs/customer-data-segment";
import styles from "./deposit-contribution.module.css";
export function DepositContributionBanner(param) {
    var sendDigitalDataEvent = param.sendDigitalDataEvent;
    var trackEvent = useCustomerData().trackEvent;
    var handleOnClick = function() {
        var data = {
            event: {
                name: "click",
                category: "link",
                action: "navigate",
                label: "selected electric cars"
            }
        };
        // TECHDEBT - currently this only fires *some* of the time,
        // there is a ticket SCD-284 to fix it and make it more accurate
        trackEvent({
            type: "track",
            eventName: "Promotion Clicked",
            data: {
                name: "Deposit contribution promo banner",
                position: "top banner"
            }
        });
        if (sendDigitalDataEvent) sendDigitalDataEvent(data);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.saveTag,
                children: "SAVE"
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: styles.text,
                children: [
                    "Up to \xa32,000 towards your finance deposit on",
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "/find-vehicle?tags=deposit-contribution",
                        onClick: handleOnClick,
                        children: "selected electric cars"
                    }),
                    ". Ends 4pm 24 Jan.",
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "/policies/deposit-contribution-electric-cars",
                        children: "T&Cs apply"
                    }),
                    ". 9.9% APR Representative."
                ]
            })
        ]
    });
}
export default DepositContributionBanner;
